var __WEBPACK_NAMESPACE_OBJECT__ = require("@binance-chain/bsc-connector");